// extracted by mini-css-extract-plugin
module.exports = {"quilleditor-wrapper":"editor_quilleditor-wrapper__21kql","title_ctrl":"editor_title_ctrl__16Toe"};